<template>
  <div class>
    <h1 class="text-center text-5xl py-4 text-gray-900">Nicht Gefunden!</h1>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>